/**
 * Dossiê de Projeto e Manual de Colaboração: Ecossistema Golden Sisters
 * Arquivo: src/pages/LoginPage.js
 * Versão: 1.2 - Código Limpo e Corrigido
 * Data: 15/07/2025
 * Responsável pela Alteração: Gemini
 * Correção: Removida a duplicação de código que causava erro de compilação.
 */
import React, { useState } from 'react';
// --- MUDANÇA 1: Importar o 'auth' diretamente ---
import { auth } from '../firebase/config';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { Mail, Lock } from 'lucide-react';

// --- MUDANÇA 2: O componente não recebe mais a prop 'auth' ---
const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        if (!email || !password) {
            setError('Por favor, preencha todos os campos.');
            return;
        }
        setLoading(true);
        setError('');
        try {
            // 'auth' agora vem da nossa importação direta, garantindo que ele sempre exista.
            await signInWithEmailAndPassword(auth, email, password);
            // O onAuthStateChanged no App.js vai detectar o login e redirecionar
        } catch (err) {
            // --- MUDANÇA 3: Log do erro completo para melhor depuração ---
            console.error("Erro de login detalhado:", err); 
            switch (err.code) {
                case 'auth/user-not-found':
                case 'auth/wrong-password':
                case 'auth/invalid-credential':
                    setError('E-mail ou senha inválidos.');
                    break;
                default:
                    setError('Ocorreu um erro ao tentar fazer login.');
                    break;
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-brand-black">
            <div className="w-full max-w-md p-8 space-y-8 bg-brand-dark rounded-xl shadow-lg">
                <div className="text-center">
                    <img src="/logo_perfil.jpg" alt="Logo Golden Sisters" className="w-24 h-24 mx-auto rounded-md mb-4" />
                    <h1 className="text-2xl font-bold text-white">Painel Administrativo</h1>
                    <p className="text-gray-400">Acesso exclusivo para administradores</p>
                </div>
                <form className="space-y-6" onSubmit={handleLogin}>
                    <div className="relative">
                        <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                            <Mail className="w-5 h-5 text-gray-400" />
                        </span>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="E-mail"
                            className="w-full pl-10 pr-3 py-2 text-white bg-gray-700 border border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-brand-gold"
                            required
                        />
                    </div>
                    <div className="relative">
                        <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                            <Lock className="w-5 h-5 text-gray-400" />
                        </span>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Senha"
                            className="w-full pl-10 pr-3 py-2 text-white bg-gray-700 border border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-brand-gold"
                            required
                        />
                    </div>

                    {error && (
                        <p className="text-sm text-center text-red-500">{error}</p>
                    )}

                    <div>
                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full px-4 py-2 font-semibold text-brand-black bg-brand-gold rounded-md hover:bg-yellow-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-brand-dark focus:ring-brand-gold disabled:bg-gray-500 disabled:cursor-not-allowed transition-colors duration-300"
                        >
                            {loading ? 'Entrando...' : 'Entrar'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default LoginPage;
